import React, { JSX } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useTourContext } from './BaseTour';

interface TourButtonProps {
  title: string;
  tourDataKey: string;
}

const TourButton = ({ title, tourDataKey }: TourButtonProps): JSX.Element => {
  const { startTour } = useTourContext();

  const clearTourData = (): void => {
    localStorage.removeItem(tourDataKey);
    window.location.reload();
  };

  const testTourElements = (): void => {
    // Tour elements will be tested when tour starts
  };

  return (
    <Tooltip title={title} arrow>
      <IconButton
        onClick={() => {
          testTourElements();
          startTour();
        }}
        sx={{
          width: 36,
          height: 36,
          p: 0,
          color: 'text.secondary',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
        onContextMenu={(e) => {
          e.preventDefault();
          clearTourData();
        }}
      >
        <PlayArrowIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default TourButton;
